<template lang="pug">
  footer(:class="[$style.footer, $style.foreignFooter, isRebrand ? $style.rebrandPadding : '']")
    div(
      :class="isRebrand? $style.rebrandLayout : ''"
      class="container font-semibold"
    )
      div(:class="$style.siteInfo")
        div(:class="$style.trustPilot")
          client-only
            LocalisedTrustpilotFooter(
              theme="light"
              :width="Breakpoints_matchMedia('md') ? null : 168")
        nav(:class="$style.links")
          a(:href="`${v4Host}/about-us`") About Us
          a(:href="`${v4Host}/categories`") Get Quotes
          a(:href="`${v4Host}/faqs/customer`") Advice Centre
          a(:href="`${v4Host}/contact-us`") Contact Us
          a(:href="`${v4Host}/become-a-transport-partner`") Drive with AnyVan
        div(:class="$style.contact")
          p(class="flex justify-center items-center md:inline")
            a(
              href="https://www.facebook.com/Anyvan.ie"
              target="_blank"
              :class="$style.mediaIcon"
              aria-label="facebook")
              Icon(
                transform="scale(0.6)"
                :size="30"
                name="i:facebook")
            a(
              href="https://x.com/AnyVanIreland"
              target="_blank"
              :class="$style.mediaIcon"
              aria-label="x")
              Icon(
                transform="scale(0.6)"
                :size="30"
                name="i:x")
            img(
              class="inline-flex md:hidden fixed-size"
              :class="$style.pciDssValidated"
              src="~/assets/img/footer/PCI_DSS_Validated.webp"
              loading="lazy"
              width="82"
              height="45"
              alt="verify logo")
          div(class="mt-ds-ms mb-ds-sm hidden md:block")
            PhoneNumber(
              :font-size="25"
              show-text
              :phone="phone")
          p(class="mb-ds-md text-xs hidden md:block")
            | We’re here from
            br
            | Monday to Friday 9am - 6pm
          p(class="mb-ds-md text-2xl hidden md:block")
            a(:href="emailHref")
              | {{email}}

      hr(:class="$style.hr")

      div(:class="$style.legal")
        nav
          a(:href="`${v4Host}/privacy-policy`" target="_blank")
            | Privacy Policy
          a(:href="`${v4Host}/terms-and-conditions`" target="_blank")
            | Terms of Use
          a(:href="`${v4Host}/sitemap`")
            | Sitemap
        div(:class="$style.copy")
          div(class="text-2xs text-center md:text-sm md:text-left")
            | Copyright © 2009-{{currentYear}} AnyVan Ltd. All rights reserved.
          div(class="hidden text-right md:block lg:hidden")
            img(
              class="inline-block fixed-size"
              :class="$style.pciDssValidated"
              src="~/assets/img/footer/PCI_DSS_Validated.webp"
              loading="lazy"
              width="82"
              height="45"
              alt="verify logo")

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth"
import { getV4Host } from "~/scripts/useful-functions"

export default defineComponent({
  name: "TheFooterIE",
  extends: FooterBase,
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    v4Host(): string {
      return getV4Host(this.$config.public.v4Host, "ie")
    }
  }
})
</script>

<style lang="scss" module>
@import "~/assets/scss/footer.scss";
</style>
